import { Injectable } from '@angular/core';
import { UserInfo } from '../models/application/user-info.model';
import { Config } from '../config';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class UserService {
  userInfo: UserInfo | undefined;

  isDevFormEditor: boolean = true;
  isDevQuestionEditor: boolean = false;
  isDevFormReviewer: boolean = true;
  isDevAdmin: boolean = true;
    constructor(
          private http: HttpClient,
     
    ){

    }

  async loadUserInfo(userName?:string): Promise<UserInfo | undefined> {
    
    const user = userName || Config.user.name;
    if(!user) return;
    const url = `${Config.authorizationApiUrl}/api/User?id=${encodeURIComponent(user)}`;
    return firstValueFrom(this.http.get<UserInfo>(url))
      .then(userInfo => {
        this.userInfo = userInfo;
        return userInfo;
      })
      .catch(err => {
        console.error(err);
        throw err;
      });

      
    // return fetch(url, {  
    //   method: 'GET'
    // })
    //   .then(res => res.json())
    //   .then(userInfo => {
    //     this.userInfo = userInfo;
    //     return userInfo;
    //   })
    //   .catch(err => console.log(err));

    
  }

  hasViewPermission(resource: string): boolean {
    const permissions = this.userInfo!.permissions || [];
    return permissions.some(
      c =>
        c.mayView &&
        c.resourceName.trim() === resource.trim() &&
        c.resourceCategoryCode === 'FDC'
    );
  }

  hasSupportUpdatePermission(): boolean {
    return this.hasResource(Config.app.supportResourceUpdate);
  }

  hasSupportViewPermission(): boolean {
    return this.hasResource(Config.app.supportResource);
  }

  private hasResource(resource: string) {
    const permissions = this.userInfo!.permissions || [];
    if (resource) {
      return permissions.some(
        c =>
          c.resourceName.trim() === resource.trim()
      );
    } else {
      return false;
    }
  }

  hasCreatePermission(resource: string): boolean {
    const permissions = this.userInfo!.permissions || [];
    return permissions.some(
      c => c.mayEdit && c.resourceName.trim() === resource.trim()
    );
  }

  isCTFormEditor() {
    if (this.userInfo) {
      const permissions = this.userInfo.permissions;
      const haveFormEditorResource = permissions.some(
        c => c.resourceName === 'FB_Design_Forms'
      );
      // const isAdmin = this.isAdmin();
      // return (haveSurveyResource && !isAdmin);
      return (haveFormEditorResource);
    } else {
      return false;
    }
  }

  isFormEditor() {
    this.isDevFormEditor = this.isCTFormEditor();
    return this.isDevFormEditor;
  }

  isCTQuestionEditor() {
    if (this.userInfo) {
      const permissions = this.userInfo?.permissions;
      const haveQuestionEditorResource = permissions?.some(
        c => c.resourceName === 'FB_Dev_Forms'
      );
      // const isAdmin = this.isAdmin();
      // return (haveSurveyResource && !isAdmin);
      return (haveQuestionEditorResource);
    } else {
      return false;
    }
  }

  isQuestionEditor() {
    if (this.isDeveloperUser()) {
      return true;
    }
    // return this.isDevQuestionEditor;
    // return this.isCTQuestionEditor();
    return false;
  }

  isCTFormReviewer() {
    if (this.userInfo) {
      const permissions = this.userInfo.permissions;
      const haveFormReviewerResource = permissions.some(
        c => c.resourceName === 'FB_Approve_Forms'
      );
      return (haveFormReviewerResource);
    } else {
      return false;
    }
  }

  isFormReviewer() {
    return this.isDevFormReviewer;
    // return this.isCTFormReviewer();
  }

  isCTAdmin() {
    if (this.userInfo) {
      const permissions = this.userInfo?.permissions;
      const haveAdminResource = permissions?.some(
        c => c.resourceName === 'FB_Admin_Forms'
      );
      return (haveAdminResource);
    } else {
      return false;
    }
  }

  isAdmin() {
    return this.isDevAdmin;
    // return this.isCTAdmin();
  }

  /**
   * TODO: Disable after updating authorization
   *
   * @returns
   */
  isDeveloperUser(): boolean {
    // CT OKTA Permissions for Devs
    const ctDevPermission = this.isCTQuestionEditor();

    if (!this.userInfo) {
      return false;
    }

    if (ctDevPermission) {
      return true;
    }
    return false;
  }
}
